/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

export interface LinkCopyIconProps extends IconProps {
  className?: string;
}

/*
 * Defines the Design Language System (DLS) Link Copy Icon component.
 */
export const LinkCopyIcon = ({
  size = IconSize.small,
  color = dlsColor('grey3'),
  className = ''
}: LinkCopyIconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});

  return (
    <svg className={className} width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14467_132262)">
        <path d="M15.79 14.5016V19.8056C15.79 20.0817 15.5661 20.3056 15.29 20.3056H3.5C3.22386 20.3056 3 20.0817 3 19.8056V8.01563C3 7.73948 3.22386 7.51562 3.5 7.51562H6" stroke={iconColor} strokeWidth="1.5"/>
        <g clipPath="url(#clip1_14467_132262)">
          <path d="M13.1032 11.668L11.8614 12.9097C11.754 13.0172 11.5797 13.0172 11.4722 12.9097L7.92508 9.36258C7.8176 9.2551 7.8176 9.08084 7.92508 8.97336L13.4186 3.47986C13.5261 3.37238 13.7003 3.37238 13.8078 3.47986L17.3549 7.027C17.4624 7.13448 17.4624 7.30874 17.3549 7.41622L15.1979 9.57329" stroke={iconColor} strokeWidth="1.5" strokeMiterlimit="10"/>
          <path d="M16.6303 4.2095L17.8756 2.96423C17.9831 2.85675 18.1574 2.85675 18.2648 2.96423L21.812 6.51137C21.9195 6.61885 21.9195 6.79312 21.812 6.9006L16.3185 12.3941C16.211 12.5016 16.0367 12.5016 15.9293 12.3941L12.3821 8.84696C12.2746 8.73948 12.2746 8.56521 12.3821 8.45773L14.5462 6.29362" stroke={iconColor} strokeWidth="1.5" strokeMiterlimit="10"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_14467_132262">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
        <clipPath id="clip1_14467_132262">
          <rect width="16.5135" height="15.4126" fill="white" transform="translate(4 8.35547) rotate(-45)"/>
        </clipPath>
      </defs>
    </svg>
  );
};
